export type DiagnosisKeys = (typeof MODIFIER_KEYS)[number];

export type DiagnosisPointer = {
  [key in DiagnosisKeys]: string[];
};

export type DiagnosisPointersReturnType = {
  options: DiagnosisPointer;
  handleChange: (key: DiagnosisKeys, value: string | null) => void;
  selectedPointers: string[];
};

export const MODIFIER_KEYS = [
  "diagnosisFirstPointers",
  "diagnosisSecondPointers",
  "diagnosisThirdPointers",
  "diagnosisFourthPointers",
] as const;
